import { useEntityScope } from '@/hooks/useEntityScope';

import { sessionPmsAccountFrom, type PmsAccountRef } from '../services/pmsAccount';

/**
 * DV-3345: the session's PMS account, for the /home pages. The ONLY place the
 * PMS layer reads the session (spec D4 lint rule). The Global Orders photos
 * page never calls this; it uses the property's account.
 */
export const useSessionPmsAccount = (): PmsAccountRef | null => sessionPmsAccountFrom(useEntityScope());
